import { AfterViewInit, Component, ElementRef, Input, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { takeUntil } from "rxjs/operators";
import { UnsubscribeComponent } from "../../generals/Components";
import { CurrencyEditor, LabelValue } from "../../interfaces/interfaces";
import { ApiService } from "../../services/api.service";

@Component({
    selector: 'app-currencyeditor',
    templateUrl: './currencyeditor.component.html',
    styleUrls: ['./currencyeditor.component.scss']
})
export class CurrencyeditorComponent extends UnsubscribeComponent implements AfterViewInit {

    @ViewChild('input') input: ElementRef<HTMLInputElement>;

    @Input() id: number = null;

    formGroup: FormGroup = null;

    dataLoading: boolean = false;

    loading: boolean = false;

    currencyEditor: CurrencyEditor = null;

    currencySignPositions: LabelValue[] = [
        { label: 'Előtte szóközzel', value: 'BEFORE_WITH_SPACE' },
        { label: 'Előtte szóköz nélkül', value: 'BEFORE' },
        { label: 'Utána szóköz nélkül', value: 'AFTER' },
        { label: 'Utána szóközzel', value: 'AFTER_WITH_SPACE' }
    ];

    thousandSeparators: LabelValue[] = [
        { label: 'Szóköz', value: ' ' },
        { label: 'Vessző', value: ',' },
        { label: 'Pont', value: '.' }
    ];

    decimalSeparators: LabelValue[] = [
        { label: 'Vessző', value: ',' },
        { label: 'Pont', value: '.' }
    ];

    init(): void {
        this.initFormGroup();
        this.loadData();
    }

    initFormGroup(): void {
        this.formGroup = new FormGroup({
            currency: new FormControl('', [Validators.required, Validators.maxLength(3), Validators.minLength(3)]),
            currencySign: new FormControl('', [Validators.required, Validators.maxLength(20)]),
            currencySignPosition: new FormControl('AFTER_WITH_SPACE'),
            thousandSeparator: new FormControl(' '),
            decimalSeparator: new FormControl(',')
        });
    }

    loadData(): void {
        if (this.id !== null) {
            this.dataLoading = true;
            this.apiService.getCurrency(this.id).pipe(takeUntil(this.unsubscribe)).subscribe((rsp) => {
                this.currencyEditor = rsp.currencyEditor;
                this.fillForm(this.currencyEditor);
            }).add(() => {
                this.dataLoading = false;
            });
        }
    }

    fillForm(currencyEditor: CurrencyEditor): void {
        this.formGroup.get('currency').setValue(currencyEditor.currency);
        this.formGroup.get('currencySign').setValue(currencyEditor.currencySign);
        this.formGroup.get('currencySignPosition').setValue(currencyEditor.currencySignPosition);
        this.formGroup.get('thousandSeparator').setValue(currencyEditor.thousandSeparator);
        this.formGroup.get('decimalSeparator').setValue(currencyEditor.decimalSeparator);
    }

    save(): void {
        if (this.formGroup.invalid) {
            return;
        }
        this.loading = true;
        const formValue: any = this.formGroup.value;
        if (this.id === null) {
            this.apiService.createCurrency(formValue).pipe(takeUntil(this.unsubscribe)).subscribe(() => {
                this.ref.close(true);
            }).add(() => {
                this.loading = false;
            });
        } else {
            this.apiService.updateCurrency(this.id, formValue).pipe(
                takeUntil(this.unsubscribe)
            ).subscribe(() => {
                this.ref.close(true);
            }).add(() => {
                this.loading = false;
            });
        }
    }

    close(result: boolean = false): void {
        this.ref.close(result);
    }

    ngAfterViewInit(): void {
        this.input.nativeElement.focus();
    }

    constructor(
        private apiService: ApiService,
        private ref: DynamicDialogRef,
        private config: DynamicDialogConfig
    ) {
        super();
        this.id = this.config.data.id;
        this.init();
    }
}
